var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container page", attrs: { id: "category-dashboard" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2",
          },
          [
            _c("back-button", {
              attrs: {
                backRoute: {
                  name: "categoryChooser",
                  params: { area: _vm.currentAreaId },
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row category-details" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "category-image" }, [
                  _c("img", {
                    staticClass: "img img-responsive",
                    attrs: { src: this.category.title_image_path },
                  }),
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.$t("CATEGORY_DASHBOARD_COURSE")))]),
                _vm._v(" "),
                _c("h1", [_vm._v(_vm._s(this.category.name))]),
                _vm._v(" "),
                _c("p", { staticClass: "category-description" }, [
                  _vm._v(_vm._s(this.category.description)),
                ]),
                _vm._v(" "),
                _vm.category.chapters
                  ? _c(
                      "div",
                      { staticClass: "category-details-progress" },
                      [
                        _c("progress-bar", {
                          attrs: {
                            percent:
                              (_vm.completeChapters /
                                _vm.category.chapters.length) *
                              100,
                            height: 12,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "progress-text" },
                          [
                            _vm._v(
                              "\n              " + _vm._s(_vm.completeChapters)
                            ),
                            _c("slash", {
                              staticStyle: {
                                width: "6px",
                                height: "10px",
                                margin: "0 2px",
                              },
                            }),
                            _c("span", { staticClass: "all-count" }, [
                              _vm._v(_vm._s(_vm.category.chapters.length)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "col-xs-12 chapters-heading" }, [
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("CATEGORY_DASHBOARD_CHAPTERS"))),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.category.chapters || [], function (chapter) {
                  return _c(
                    "div",
                    { key: chapter.id, staticClass: "col-xs-12" },
                    [
                      _c("div", { staticClass: "card chapter-card" }, [
                        _c("div", { staticClass: "title-container" }, [
                          _c(
                            "h2",
                            [
                              chapter.type === "article"
                                ? _c("article-icon", {
                                    staticClass: "svg-icon medium",
                                  })
                                : chapter.type === "video"
                                ? _c("video-icon", {
                                    staticClass: "svg-icon medium",
                                  })
                                : chapter.type === "trivia"
                                ? _c("trivia-icon", {
                                    staticClass: "svg-icon medium",
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                " +
                                  _vm._s(chapter.name) +
                                  "\n              "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          chapter.description
                            ? _c("p", { staticClass: "chapter-description" }, [
                                _vm._v(_vm._s(chapter.description)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "chapter-progress-button" }, [
                          _c(
                            "div",
                            { staticStyle: { position: "relative" } },
                            [
                              _c("progress-bar", {
                                attrs: {
                                  percent: _vm.chapterProgressPercent(chapter),
                                },
                              }),
                              _vm._v(" "),
                              _vm.chapterProgressPercent(chapter) === 100
                                ? _c("check", {
                                    staticClass: "svg-icon",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-14px",
                                      top: "-14px",
                                      "z-index": "1",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn primary-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.goToChapter(chapter.id)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.chapterProgressPercent(chapter) === 0
                                      ? _vm.$t("BEGIN")
                                      : _vm.chapterProgressPercent(chapter) ===
                                        100
                                      ? _vm.$t("VIEW_AGAIN")
                                      : _vm.$t("CONTINUE")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }